const importAllImages = (r, json) => {
    let images = {};
    json.forEach(item => {
        images[item.src] = r(`./${item.src}`);
    });
    return images;
};

export default importAllImages;